import React from "react";
import { Award } from "lucide-react";
import { CONSIGLIO } from "../data/content";
import Reveal from "../components/site/Reveal";

export default function ConsiglioPage() {
  return (
    <div className="pt-20">
      <section data-testid="consiglio-section" className="bg-cream py-20 md:py-28">
        <div className="mx-auto max-w-[1400px] px-4 md:px-8 lg:px-12">
          <div className="max-w-3xl mb-12">
            <Reveal>
              <p className="font-sub uppercase tracking-[0.3em] text-court font-bold text-sm mb-4">
                La Società
              </p>
              <h1 className="font-heading uppercase leading-[0.9] text-navy text-4xl md:text-6xl tracking-tight">
                Il Consiglio Direttivo
              </h1>
              <div className="mt-5 inline-block bg-navy text-gold font-heading uppercase text-xl md:text-2xl px-5 py-2">
                Quadriennio {CONSIGLIO.period}
              </div>
            </Reveal>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {CONSIGLIO.members.map((m, i) => {
              const featured = m.role !== "Consigliere";
              return (
                <Reveal key={m.name} delay={0.03 * (i % 3)}>
                  <div
                    data-testid={`consiglio-member-${i}`}
                    className={`h-full border-4 border-navy p-6 flex flex-col justify-between ${
                      featured ? "bg-navy text-white shadow-hard-orange" : "bg-white text-navy"
                    }`}
                  >
                    <div
                      className={`font-sub uppercase tracking-widest text-xs font-bold ${
                        featured ? "text-gold" : "text-court"
                      }`}
                    >
                      {m.role}
                    </div>
                    <div className="font-heading uppercase text-2xl md:text-3xl leading-none mt-6">
                      {m.name}
                    </div>
                  </div>
                </Reveal>
              );
            })}
          </div>

          <div className="mt-20">
            <Reveal>
              <div className="flex items-center gap-3 mb-8">
                <Award className="text-court" size={28} />
                <h2 className="font-heading uppercase text-navy text-3xl md:text-4xl tracking-tight">
                  L&apos;Albo dei Presidenti
                </h2>
              </div>
            </Reveal>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-px bg-navy/15 border border-navy/15">
              {CONSIGLIO.presidenti.map((p, i) => (
                <Reveal key={p} delay={0.02 * (i % 4)} className="bg-cream">
                  <div className="flex items-center gap-4 p-5" data-testid={`presidente-${i}`}>
                    <span className="font-heading text-court text-2xl leading-none w-8">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    <span className="font-body font-600 text-navy">{p}</span>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
